// IosEmailComposer — thin Dialog wrapper around IosEmailComposerBody.
//
// Existing callers (ChecklistItemRow, TaskColumnView, ActionPanel/EmailActionBody)
// use this component — it behaves identically to the pre-refactor version.
// New callers that need the compose UI embedded inline (e.g. popup sidebar Email
// tab) should import IosEmailComposerBody directly instead.
import PropTypes from 'prop-types';
import { Dialog, Grow, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import IosEmailComposerBody from './IosEmailComposerBody';

export default function IosEmailComposer({ open, onClose, leadId, templateId, practiceId, onSendSuccess, leadDetail }) {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Grow}
            TransitionProps={{ timeout: 180 }}
            fullWidth
            fullScreen={isMobile}
            maxWidth="lg"
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(4px)',
                    backgroundColor: 'rgba(0,0,0,0.32)',
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: isMobile ? 0 : '16px',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: 24,
                    border: `1px solid ${theme.palette.divider}`,
                    overflow: 'hidden',
                },
            }}
        >
            {/* Conditionally render body so state resets automatically on close */}
            {open && (
                <IosEmailComposerBody
                    leadId={leadId}
                    templateId={templateId}
                    practiceId={practiceId}
                    onSendSuccess={onSendSuccess}
                    leadDetail={leadDetail}
                    onDismiss={onClose}
                />
            )}
        </Dialog>
    );
}

IosEmailComposer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSendSuccess: PropTypes.func,
    leadDetail: PropTypes.object,
};
